/**
 * Tarjetas del tablero del Rodeo de Cría.
 *
 * Cada tarjeta abre `ModalDashboardFilter` con una categoría y una subcategoría, y su número
 * sale de `GET /cria/pendientes/tarjetas` (`conteos[categoria][subcategoria]`), que usa las
 * mismas reglas que la lista del modal (`GET /grilla_vaca/pendientes`).
 */

/** `clave` es la de `conteosPendientes` en RodeoCriaView. */
export const TARJETAS_DASHBOARD_CRIA = Object.freeze([
  {
    clave: "tacto_preservicio",
    categoria: "reproduccion",
    subcategoria: "tacto_preservicio",
  },
  {
    clave: "listos_servicio",
    categoria: "reproduccion",
    subcategoria: "inseminacion",
  },
  {
    clave: "observacion_celo",
    categoria: "reproduccion",
    subcategoria: "observacion_celo",
  },
  {
    clave: "tacto_prenez",
    categoria: "reproduccion",
    subcategoria: "tacto_prenez",
  },
  {
    clave: "vacas_preniadas_o_reproduccion",
    categoria: "reproduccion",
    subcategoria: "vacas_preniadas_reproduccion",
  },
  { clave: "proximas_parto", categoria: "reproduccion", subcategoria: "parto" },
  { clave: "preniadas", categoria: "reproduccion", subcategoria: "preniadas" },
  {
    clave: "terneros_al_pie",
    categoria: "recria",
    subcategoria: "terneros_al_pie",
  },
  {
    clave: "capados_pendientes",
    categoria: "recria",
    subcategoria: "capados_pendientes",
  },
  {
    clave: "destetes_pendientes",
    categoria: "recria",
    subcategoria: "destete",
  },
  {
    clave: "toros_adultos_monta",
    categoria: "reproduccion",
    subcategoria: "toros_adultos_monta",
  },
  {
    clave: "sugerencias_venta",
    categoria: "ventas",
    subcategoria: "sugerencias_venta",
  },
]);
